export default __webpack_public_path__ + "static/media/46.b5206769.jpg";